import { Component } from '@angular/core';

@Component({
  selector: 'calsoft-monitor-performance',
  templateUrl: './monitor-performance.component.html',
  styleUrls: ['./monitor-performance.component.scss']
})
export class MonitorPerformanceComponent {

}
